/*
  The hyros tracking script fucks up some of our URLs:

  When the user views search results: https://www.sharedeals.de/?s=foo ,
  the script parses the URL false:
  1. removes the first `/` in path when it is succeeded by a `?`
  => https://www.sharedeals.de?s=foo
  2. it cuts the URL at the "last" `/`, which is the one after `https:/``
  => `www.sharedeals.de` , `s=foo`
  3. It searches for some tracking params etc and then rebuilds the url.
  => `www.sharedeals.de?s=foo``
  4. Then, it applies it to history.replaceState, which interprets it as relative URL, which results in the visible URL:
  => https://www.sharedeals.de/www.sharedeals.de/?s=foo
  5. Back-Button is broken.

  Fix: we prepend the protocol if the supplied "relative" path starts with our hostname


  na() {
            var e = location.href.replace("/?", "?")￼e = "staging.sharedeals.de"
              , [e,t] = e.substring(e.lastIndexOf("/") + 1).split("?");￼t = "pushtest=422"
            let r = new URLSearchParams(t);
            return z().forEach(e => r.delete(e)),
            Object.values(K).forEach(e => {
                e.split(",").map(e => e.trim()).filter(Boolean).forEach(e => r.delete(e))
            }
            ),
            e + ((r.toString() && "?") + decodeURIComponent(r.toString()))
  }


*/

export default function historyStateHack(history) {
  const originalHistoryReplaceState = history.replaceState.bind(history)

  history.replaceState = function(x, title, url) {
    if (url && url.startsWith(window.location.hostname)) {
      url = window.location.protocol + '//' + url
      console.debug("History.replaceState Hack triggered")
    }
    return originalHistoryReplaceState(x, title, url)
  }
  console.debug("History.replaceState Hack applied")
}
